import { FC, Fragment } from "react";
// Redux
import { useAppSelector } from "hooks/useStore";
import { selectQuestions } from "store/quiz/quizzesSelectors";
import IQuestion from "models/Question";
// Components
import QuestionItem from "./QuestionItem";
import { Message } from "components/Utilities";
// i18next
import { useTranslation } from "react-i18next";

const QuestionsList:FC = () => {
  const { t } = useTranslation();

  const questions = useAppSelector(selectQuestions);
  
  if (!questions.length) return (
    <Message text={t('pages.answersAnalytics.noQuestionsData')} />
  )
  return (
    <Fragment>
      {questions.map((question:IQuestion, questionIndex:number) => (
        <QuestionItem key={question.ref} question={question} questionIndex={questionIndex} />
      ))}
    </Fragment>
  );
}
 
export default QuestionsList;
